import React, { useState, useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { get } from '../../../services/apiController';
import { useLocation } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { Table } from 'react-bootstrap';

const KitchenConsolidatedPrint = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const factoryId = queryParams.get('factoryId');
  const kitchenId = queryParams.get('kitchenId');
  const dateFrom = queryParams.get('dateFrom');
  const dateTo = queryParams.get('dateTo');
  const [data, setData] = useState([]);
  const [factory, setFactory] = useState({});

  useEffect(() => {
    if (factoryId) {
      get('/branches/?id=' + factoryId).then((branch) => {
        if (branch.data.rows.length) {
          setFactory(branch.data.rows[0]);
        }
      });
    }
  }, [factoryId]);

  useEffect(() => {
    if (factoryId && kitchenId) {
      get(`/inv/report/kitchen-consolidated/?kitchenId=${kitchenId}&factoryId=${factoryId}&dateFrom=${dateFrom}&dateTo=${dateTo}`)
        .then((res) => setData(res?.data))
        .catch((err) => toast.error(err?.response?.data.data.message || err?.message));
    }
  }, [factoryId, kitchenId, dateFrom, dateTo]);

  return (
    <>
      <ToastContainer />
      <div className="grn-detail print-view me-5 ms-5">
        <div className="text-center">
          <div className="mb-3">
            <h4 className="m-0 mb-2">Kanti Sweets Private Limited</h4>
            <h6 className="m-0" style={{ fontSize: '12px' }}>
              {factory?.name}
              <br />
              {factory?.address}
            </h6>
          </div>
        </div>

        <Table striped bordered className="text-center grn-detail-table">
          <thead>
            <tr>
              <th style={{ width: '10%' }}>Kitchen</th>
              <th style={{ width: '30%' }}>Indent Numbers</th>
              <th style={{ width: '45%' }}>Item</th>
              <th style={{ width: '15%' }}>Quantity</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => {
              const rowSpan = item.items_details.length;
              const item_details = item?.items_details;
              return (
                <>
                  <tr key={item?.id}>
                    <td rowSpan={rowSpan} style={{ verticalAlign: 'top' }}>
                      {item.kitchen_name}
                    </td>
                    <td rowSpan={rowSpan} style={{ verticalAlign: 'top' }}>
                      {item?.productionIndentNumbers.join(', ')}
                    </td>
                    <td>{`${item_details[0]?.name} (${item_details[0]?.unit})`}</td>
                    <td>{item_details[0]?.quantity}</td>
                  </tr>
                  {item_details.map((detail, _index) => {
                    if (_index === 0) {
                      return null;
                    }
                    return (
                      <tr>
                        <td>{`${detail.name} (${detail.unit})`}</td>
                        <td>{detail?.quantity}</td>
                      </tr>
                    );
                  })}
                </>
              );
            })}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default KitchenConsolidatedPrint;
